import {
  Apresentation,
  ContainerApresentation,
  SectionButtons,
  StyledTitleApresentation,
} from "./styled";
import Button from "../../../ui/Button";
import { useNavigate } from "react-router";
import { goToPage } from "../../../../App";

function WelcomeSection() {
  const background = "./images/utils/apresentation.webp";
  const navigate = useNavigate();

  return (
    <ContainerApresentation $bgImage={background}>
      <Apresentation>
        <h1> Bem vindo a YesCooking</h1>
        <StyledTitleApresentation>
          A nossa missão é fazer missão!
        </StyledTitleApresentation>
        <SectionButtons>
          <Button
            onClick={() => goToPage(navigate, "servicos")}
            as="a"
            variant="primary"
          >
            Conheça
          </Button>
        </SectionButtons>
      </Apresentation>
    </ContainerApresentation>
  );
}

export default WelcomeSection;
